// Componente que muestra un resumen de totales de requerimientos, permitiendo editar algunos valores
export const ResumenTotalesRequerimientos = ({ formulario, setFormulario, monedaActiva }) => {
    // Formateador de números para mostrar valores con dos decimales
    const formatter = new Intl.NumberFormat("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });

    // Función que limpia un valor de texto, dejando solo números y puntos decimales
    const limpiarSubtotal = (valor) => parseFloat((valor || "").toString().replace(/[^0-9.]/g, "")) || 0;

    // Función para actualizar un campo en el objeto totalRequerimientos y recalcular el total A&B
    const actualizarCampoRequerimiento = (campo, valor) => {
        setFormulario((prev) => {
            const nuevoValor = parseFloat(valor) || 0; // Convierte el valor a número o 0 si no es válido

            // Actualiza el campo correspondiente dentro de totalRequerimientos
            const nuevosRequerimientos = {
                ...prev.totalRequerimientos,
                [campo]: nuevoValor,
            };

            // Calcula el total A&B sumando subtotal, impuesto de venta e impuesto de servicio
            const subtotal = limpiarSubtotal(nuevosRequerimientos.subtotal) || 0;
            const impuestoVenta = limpiarSubtotal(nuevosRequerimientos.impuestoVenta) || 0;
            const impuestoServicio = limpiarSubtotal(nuevosRequerimientos.impuestoServicio) || 0;

            const totalABCalculado = subtotal + impuestoVenta + impuestoServicio;

            // Retorna el nuevo estado del formulario con el total A&B actualizado
            return {
                ...prev,
                totalRequerimientos: {
                    ...nuevosRequerimientos,
                    totalAB: formatter.format(totalABCalculado), // Formatea el total A&B para mostrarlo correctamente
                },
            };
        });
    };
    return (
        <div className="invoice-total ms-auto p-3 border rounded shadow-sm">
            <h5 className="text-primary mb-3">Resumen Total {monedaActiva}</h5>
            <div className="row align-items-center mb-2">
                <div className="col-6">
                    <p className="text-muted mb-0 text-start">SUB TOTAL {monedaActiva} :</p>
                </div>
                <div className="col-6 text-end">
                    <input
                        disabled
                        style={{ minWidth: 120, fontWeight: "bold", textAlign: "right" }}
                        type="text"
                        className="form-control"
                        value={formulario.totalRequerimientos.subtotal}
                    />
                </div>
            </div>
            <div className="row align-items-center mb-2">
                <div className="col-6">
                    <p className="text-muted mb-0 text-start">13% IMP. VENTA {monedaActiva} :</p>
                </div>
                <div className="col-6 text-end">
                    <input
                        onChange={(e) => actualizarCampoRequerimiento("impuestoVenta", e.target.value)}
                        style={{ minWidth: 120, fontWeight: "bold", textAlign: "right" }}
                        type="text"
                        className="form-control"
                        value={formulario.totalRequerimientos.impuestoVenta}
                    />
                </div>
            </div>
            <div className="row align-items-center mb-2">
                <div className="col-6">
                    <p className="text-muted mb-0 text-start">10% IMP. SERVICIO {monedaActiva} :</p>
                </div>
                <div className="col-6 text-end">
                    <input
                        onChange={(e) => actualizarCampoRequerimiento("impuestoServicio", e.target.value)}
                        style={{ minWidth: 120, fontWeight: "bold", textAlign: "right" }}
                        type="text"
                        className="form-control"
                        value={formulario.totalRequerimientos.impuestoServicio}
                    />
                </div>
            </div>
            <div className="row align-items-center">
                <div className="col-6">
                    <p className="text-dark fw-bold mb-0 text-start">TOTAL A&B {monedaActiva} :</p>
                </div>
                <div className="col-6 text-end">
                    <input
                        disabled
                        style={{
                            minWidth: 120,
                            fontWeight: "bold",
                            textAlign: "right",
                            backgroundColor: "#f8f9fa",
                            border: "1px solid #ced4da",
                        }}
                        type="text"
                        className="form-control"
                        value={formulario.totalRequerimientos.totalAB}
                    />
                </div>
            </div>
        </div>
    );
};
